import { netMoic } from '@foresightdata/metrics-calculator';
import { format } from '../../../pages/PortfolioOverview/services/kpi/kpi-formatter';
import { KpiConfig, KPI_COMPONENTS, KpiConfigMeta, KpiCalculationParams, Kpi } from '../../../types';

export class AdjustedMOICConfig implements KpiConfig {
  private id = KPI_COMPONENTS.ADJUSTED_MOIC as const;
  private title = 'Adjusted MOIC';
  private type = 'multiple';

  getMeta(): KpiConfigMeta {
    return {
      id: this.id,
      title: this.title,
      type: this.type,
    };
  }

  calculate({ data }: KpiCalculationParams): Kpi {
    const value =
      data?.metrics
        ?.filter((metric) => metric != null)
        .reduce((prev, t) => prev + (netMoic(t as unknown as Parameters<typeof netMoic>[0]) || 0), 0) ?? 0;

    return {
      ...this.getMeta(),
      value,
      formatted: format(value, this.type),
    };
  }
}
